export const getLangWithCountryCode = (lang: string, territory: string): string | undefined => {
  const langWithCountryCodeRegex = /^[a-z]{2}-[A-Z]{2}$/;
  const langWithCountryCode = `${lang}-${territory}`;
  return langWithCountryCodeRegex.test(langWithCountryCode) ? langWithCountryCode : undefined;
};
